export default[{
  "id": "1921307543458365440",
  "createTime": null,
  "updateTime": null,
  "icon": "el-icon-s-home",
  "name": "系统首页",
  "hidden": false,
  "component": "components/layout/Home",
  "path": "/home",
  "parentId": "0",
  "parentName": null,
  "redirect": "",
  "sort": 1,
  "level": 1,
  "requiresAuth": true,
  "showChild": 0,
  "type": 1,
  "identification": null,
  "children": [{
    "id": "1921385574424272896",
    "createTime": null,
    "updateTime": null,
    "icon": "el-icon-s-home",
    "name": "首页",
    "hidden": true,
    "component": "page/dashboard",
    "path": "/home",
    "parentId": "1921307543458365440",
    "parentName": "系统首页",
    "redirect": "",
    "sort": 1,
    "level": 2,
    "requiresAuth": true,
    "showChild": 0,
    "type": 1,
    "identification": null,
    "children": [],
    "meta": {
      "label": "1921385574424272896"
    }
  }],
  "meta": {
    "label": "1921307543458365440"
  }
},{
  "id": "1921440687444647936",
  "createTime": null,
  "updateTime": null,
  "icon": "el-icon-user",
  "name": "系统权限",
  "hidden": false,
  "component": "components/layout/Home",
  "path": "/system",
  "parentId": "0",
  "parentName": null,
  "redirect": "",
  "sort": 5,
  "level": 1,
  "requiresAuth": true,
  "showChild": 1,
  "type": 1,
  "identification": null,
  "children": [{
    "id": "1921441512078368768",
    "createTime": null,
    "updateTime": null,
    "icon": "el-icon-user",
    "name": "菜单管理",
    "hidden": false,
    "component": "page/system/menu/menuList",
    "path": "/menuList",
    "parentId": "1921440687444647936",
    "parentName": "系统权限",
    "redirect": "",
    "sort": 1,
    "level": 2,
    "requiresAuth": true,
    "showChild": 0,
    "type": 1,
    "identification": null,
    "children": [],
    "meta": {
      "label": "1921441512078368768"
    }
  }, {
    "id": "1921442044654313472",
    "createTime": null,
    "updateTime": null,
    "icon": "el-icon-user",
    "name": "角色管理",
    "hidden": false,
    "component": "page/system/role/roleList",
    "path": "/roleList",
    "parentId": "1921440687444647936",
    "parentName": "系统权限",
    "redirect": "",
    "sort": 2,
    "level": 2,
    "requiresAuth": true,
    "showChild": 0,
    "type": 1,
    "identification": null,
    "children": [],
    "meta": {
      "label": "1921442044654313472"
    }
  }, {
    "id": "1928796643573678080",
    "createTime": null,
    "updateTime": null,
    "icon": "el-icon-user",
    "name": "组织管理",
    "hidden": false,
    "component": "page/system/tenant/tenantList",
    "path": "/tenantList",
    "parentId": "1921440687444647936",
    "parentName": "系统权限",
    "redirect": "",
    "sort": 3,
    "level": 2,
    "requiresAuth": true,
    "showChild": 0,
    "type": 1,
    "identification": null,
    "children": [],
    "meta": {
      "label": "1928796643573678080"
    }
  }, {
    "id": "1948284061251780608",
    "createTime": null,
    "updateTime": null,
    "icon": "",
    "name": "角色成员管理",
    "hidden": true,
    "component": "page/system/role/memberList",
    "path": "/memberLIst/:id",
    "parentId": "1921440687444647936",
    "parentName": "系统权限",
    "redirect": "",
    "sort": 3,
    "level": 2,
    "requiresAuth": true,
    "showChild": 0,
    "type": 1,
    "identification": null,
    "children": [],
    "meta": {
      "label": "1948284061251780608"
    }
  }, {
    "id": "1927529233084039168",
    "createTime": null,
    "updateTime": null,
    "icon": "el-icon-user",
    "name": "用户管理",
    "hidden": false,
    "component": "page/system/user/userList",
    "path": "/userList",
    "parentId": "1921440687444647936",
    "parentName": "系统权限",
    "redirect": "",
    "sort": 4,
    "level": 2,
    "requiresAuth": true,
    "showChild": 0,
    "type": 1,
    "identification": null,
    "children": [],
    "meta": {
      "label": "1927529233084039168"
    }
  }, {
    "id": "1933204413892132864",
    "createTime": null,
    "updateTime": null,
    "icon": "",
    "name": "新增用户",
    "hidden": true,
    "component": "page/system/user/edit",
    "path": "/addUser",
    "parentId": "1921440687444647936",
    "parentName": "系统权限",
    "redirect": "",
    "sort": 5,
    "level": 2,
    "requiresAuth": true,
    "showChild": 0,
    "type": 1,
    "identification": null,
    "children": [],
    "meta": {
      "label": "1933204413892132864"
    }
  }, {
    "id": "1933205135446638592",
    "createTime": null,
    "updateTime": null,
    "icon": "",
    "name": "编辑用户",
    "hidden": true,
    "component": "page/system/user/edit",
    "path": "/editUser/:id",
    "parentId": "1921440687444647936",
    "parentName": "系统权限",
    "redirect": "",
    "sort": 6,
    "level": 2,
    "requiresAuth": true,
    "showChild": 0,
    "type": 1,
    "identification": null,
    "children": [],
    "meta": {
      "label": "1933205135446638592"
    }
  }, {
    "id": "1933205925720621056",
    "createTime": null,
    "updateTime": null,
    "icon": "",
    "name": "用户详情",
    "hidden": true,
    "component": "page/system/user/detail",
    "path": "/userDetail/:id",
    "parentId": "1921440687444647936",
    "parentName": "系统权限",
    "redirect": "",
    "sort": 7,
    "level": 2,
    "requiresAuth": true,
    "showChild": 0,
    "type": 1,
    "identification": null,
    "children": [],
    "meta": {
      "label": "1933205925720621056"
    }
  }],
  "meta": {
    "label": "1921440687444647936"
  }
}]



